import ChessRestClient from '@/Api/ChessRestClient';
import { useQuery } from '@tanstack/react-query';
import { autoCompletionResponse } from './types';

interface UseTournamentNameAutocompleteOptions {
    enabled?: boolean;
    minLength?: number;
    staleTime?: number;
    cacheTime?: number;
}

export default function useTournamentNameAutocomplete(
    searchTerm: string,
    options: UseTournamentNameAutocompleteOptions = {},
) {
    const normalized = (searchTerm || '').trim();
    const minLength = options.minLength ?? 3;
    const shouldFetch =
        options.enabled !== false && normalized.length >= minLength;

    return useQuery<autoCompletionResponse, Error>(
        ['tournament-autocomplete', normalized],
        async () => {
            const params = new URLSearchParams({ name: normalized });
            const response = await ChessRestClient.get(
                `/v1/tournament-name/?${params.toString()}`,
            );
            return response.data;
        },
        {
            enabled: shouldFetch,
            staleTime: options.staleTime ?? 5 * 60 * 1000,
            cacheTime: options.cacheTime ?? 10 * 60 * 1000,
            keepPreviousData: true,
        },
    );
}